#import "../fragments/user-email-fragment.graphql"

mutation createUserEmailAddress($emailAddress: String!) {
    userEmailCreate(input: {emailAddress: $emailAddress}) {
        userEmail {
            ...UserEmail
        }
    }
}
